module.exports = __webpack_public_path__ + "img/inform-no.de17986f.svg";